import { render, staticRenderFns } from "./AddPickupModal.vue?vue&type=template&id=7bb1fd34"
import script from "./AddPickupModal.vue?vue&type=script&lang=js"
export * from "./AddPickupModal.vue?vue&type=script&lang=js"
import style0 from "./AddPickupModal.vue?vue&type=style&index=0&id=7bb1fd34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports